import React from 'react'
import { Card, CardText } from 'material-ui/Card'
import { ViewTitle } from 'admin-on-rest/lib/mui'

export default () => (
  <Card>
    <ViewTitle title="Ordinul Asistenților Medicali Generaliști, Moașelor și Asistenților Medicali din România, Filiala Timiș" />
    <CardText>
      Bine ati venit pe pagina de management de cursuri. Mai multe detalii
      gasiti pe site-ul oficial <a href="http://www.oammr-timis.ro/">aici</a>
    </CardText>
  </Card>
)



// WEBPACK FOOTER //
// ./src/dashboard.js